import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
  withCredentials: true,
});

// PUBLIC — case wizard + summary + checkout
export const createCase = (payload) => api.post("/cases", payload).then((r) => r.data);
export const getCase = (id) => api.get(`/cases/${id}`).then((r) => r.data);
export const updateCase = (id, payload) => api.put(`/cases/${id}`, payload).then((r) => r.data);
export const requestConsultation = (id) => api.post(`/cases/${id}/request-consultation`).then((r) => r.data);
export const getScore = (id) => api.get(`/cases/${id}/score`).then((r) => r.data);
export const createLead = (payload) => api.post("/leads", payload).then((r) => r.data);

// ADMIN — custody / saggio / verbale (require admin session)
export const createCustody = (payload) => api.post("/custody", payload).then((r) => r.data);
export const getCustody = (id) => api.get(`/custody/${id}`).then((r) => r.data);
export const generateSampleProtocol = (payload) => api.post("/sample-protocol", payload).then((r) => r.data);
export const custodyReceiptUrl = (id) => `${API}/custody/${id}/receipt`;

export const saveSaggioToCase = (caseId, payload) => api.post(`/cases/${caseId}/saggi`, payload).then((r) => r.data);
export const listCaseSaggi = (caseId) => api.get(`/cases/${caseId}/saggi`).then((r) => r.data);
export const deleteSaggio = (saggioId) => api.delete(`/saggi/${saggioId}`).then((r) => r.data);
export const savedSaggioPdfUrl = (saggioId) => `${API}/saggi/${saggioId}/pdf`;

export const getSigningInfo = () => api.get("/signing/info").then((r) => r.data);
export const signedPdfUrl = (vid) => `${API}/verbale-accesso/${vid}/signed-pdf`;
export const signedP7mUrl = (vid) => `${API}/verbale-accesso/${vid}/signed-p7m`;

// FASE E.3 · TURNO 1 (A) — post-report user-initiated revision.
// Reuses the existing E.2 revision architecture (create_admin_revision)
// but exposes it via a PUBLIC endpoint keyed only by case_id so the
// case owner can correct declarative data without an admin session.
export const createPublicRevision = (caseId, payload) =>
  api.post(`/cases/${caseId}/revisions`, payload).then((r) => r.data);

export const adminListRevisions = (caseId) =>
  api.get(`/admin/cases/${caseId}/revisions`).then((r) => r.data);
export const adminGetRevision = (caseId, n) =>
  api.get(`/admin/cases/${caseId}/revisions/${n}`).then((r) => r.data);
export const adminCreateRevision = (caseId, payload) =>
  api.post(`/admin/cases/${caseId}/revisions`, payload).then((r) => r.data);
export const adminListNotes = (caseId, params) =>
  api.get(`/admin/cases/${caseId}/notes`, { params }).then((r) => r.data);
export const adminCreateNote = (caseId, payload) =>
  api.post(`/admin/cases/${caseId}/notes`, payload).then((r) => r.data);
export const adminUpdateNote = (caseId, noteId, patch) =>
  api.put(`/admin/cases/${caseId}/notes/${noteId}`, patch).then((r) => r.data);
